import { useContext, useMemo } from "react";
import Valve from "../components/Valve";
import Transmitter4 from "../components/Transmitter4";
import Transmitter from "../components/Transmitter";
import "./SludgeCatcher.css";
import ControlValveControlPanel from "../components/ControlValveControlPanel";
import { useState, useEffect } from "react";
import { WellContext } from "../context/WellContext";
import { AlarmContext } from "../context/AlarmContext";
import LevelTransmitterIndicator from "../components/LevelTransmitterIndicator";

import { trackPageVisit } from "../competency/PageTracker";



 
      /* ✅ CONTROL VALVE PERCENTAGE OUTPUT Indicator */
                function ValveOutput({ value, x, y, r=0 }) {
                return (
                  <div
                    style={{
                      position: "absolute",
                      left: x,
                      top: y,
                      color: "white",
                      fontSize: "10px",
                      padding: "2px 6px",
                      borderRadius: "4px",
                      transform: `rotate(${r}deg)`,
                      transformOrigin: "center",
                      cursor: "pointer"
                    }}
                  >
                    {value.toFixed(1)}
                  </div>
                );
              }


function SludgeCatcher() {

        useEffect(() => {
  
    trackPageVisit("SludgeCatcher");
  
  }, []);

   const {  valves, toggleValve, transmitters} = useContext(WellContext);
     const { levels } = useContext(WellContext);


  
  const DEFAULT_VALVES = {
  FCV_2701: { mode: "Manual", opening: 0, sp: "", pv: "" },

};

const [valveData, setValveData] = useState(() => {
  const saved = localStorage.getItem("SludgeCatcher_valveData");

  if (!saved) return DEFAULT_VALVES;

  try {
    const parsed = JSON.parse(saved);

    // ✅ Merge saved + default (CRITICAL)
    return {
      FCV_2701: { ...DEFAULT_VALVES.FCV_2701, ...parsed.FCV_2701 },
    };

  } catch {
    return DEFAULT_VALVES;
  }
});



/* ✅ Persist */
  useEffect(() => {
    localStorage.setItem("SludgeCatcher_valveData", JSON.stringify(valveData));
  }, [valveData]);

  /* ================= ✅ FIXED UPDATE FUNCTION ================= */
  const updateValveData = (tag, field, value) => {
  setValveData(prev => ({
    ...prev,
    [tag]: {
      ...(prev[tag] || DEFAULT_VALVES[tag]),
      [field]: field === "opening" ? Number(value) || 0 : value
    }
  }));
};

  /* ================= PANEL CONTROL ================= */
  const [openPanels, setOpenPanels] = useState([]);

  const openPanel = (tag) => {
    if (!openPanels.includes(tag)) {
      setOpenPanels(prev => [...prev, tag]);
    }
  };

  const closePanel = (tag) => {
    setOpenPanels(prev => prev.filter(p => p !== tag));
  };


// ================= INFLOW LOGIC from PRODUCTION HEADER-1 to FIRST STAGE SEPARATOR CRUDE LEVEL TRANSMITTER =================

     

      const isXV_2701Open = !valves?.XV_2701;
      const isXV_2702Open = !valves?.XV_2702;
      const isXV_2703Open = !valves?.XV_2703;

      const crudeFlow2 = Number(transmitters?.MPFT_10701 ?? 0);
      const waterFlow2 = Number(transmitters?.MPFT_10703 ?? 0);
      const gasFlow2 = Number(transmitters?.MPFT_10702 ?? 0);

     
      /* GAS TRANSMITTER */
      const FIC_2702 = isXV_2702Open ? gasFlow2 : 0;
      const FIC_2703 = FIC_2702 * 0.99;
      const FIC_2703a = FIC_2702 * 0.01;
      const FIC_2706 = isXV_2703Open ? 9.53 *  (valveData?.FCV_2701?.opening || 0)/100 : 0;
      
      // ======================================================
// FIC_2701 NORMAL FLOW
// ======================================================

const FIC_2701 = isXV_2702Open ? Number((crudeFlow2 + waterFlow2).toFixed(3)) : 0;

      const FIC_2705 = isXV_2701Open ? 5.212 * (valveData?.FCV_2701?.opening || 0)/100 : 0;
      const FIC_2704 = FIC_2706 + FIC_2705;

    

      const PT_2701 = isXV_2702Open ? Number(transmitters?.PT_10701 ?? 0) : 0.03;
      const PT_2702 = isXV_2702Open ? (PT_2701 * 0.93) : 0.03;
      const TT_2701 = isXV_2702Open ? Number(transmitters?.TT_10701 ?? 0) : 22;


    const { setTransmitters } = useContext(WellContext);
      useEffect(() => {
        setTransmitters(prev => ({
          ...prev,
          FIC_2704: FIC_2704
        }));
      }, [FIC_2704]);

      useEffect(() => {
        setTransmitters(prev => ({
          ...prev,
          FIC_2703: FIC_2703
        }));
      }, [FIC_2703]);

      useEffect(() => {
            localStorage.setItem("FIC_2703", FIC_2703);
          }, [FIC_2703]);

          useEffect(() => {
            localStorage.setItem("PT_2702", PT_2702);
          }, [PT_2702]);


     


  return (
    <div className="SludgeCatcher-container">
      {/* TITLE */}
      <h2 style={{
        position: "absolute",
        top: "0px",
        left: "256px",
        color: "white",
        background: "rgb(29, 5, 245)",
        padding: "2px 279px"
      }}>
        SLUDGE CATCHER
      </h2>

      {/* =================SHUTDOWN VALVES ================= */}

      
      {/* XV-2701 */}
      <Valve
        className="XV-2701"
        tag="XV_2701"
        x={842}
        y={424}
        isClosed={valves.XV_2701}
        toggle={toggleValve}
      />

      {/* XV-2702 */}
      <Valve
        className="XV-2702"
        tag="XV_2702"
        x={105}
        y={257}
        isClosed={valves.XV_2702}
        toggle={toggleValve}
        r={90}
      />

      
      {/* XV-2703 */}
      <Valve
        className="XV-2703"
        tag="XV_2703"
        x={558}
        y={360}
        isClosed={valves.XV_2703}
        toggle={toggleValve}
        r={90}
      />


      
        {/* ================= CONTROL VALVES SVG ================= */}
        

         {/* FCV-2701 */}
        <svg width="80" height="50" viewBox="0 0 200 220" className="FCV-2701"
          style={{ position: "absolute", left: 335, top: 512}}  onClick={() => openPanel("FCV_2701")}>
          
          <defs>
            <linearGradient id="metal_2701">
              <stop offset="0%" stopColor="#bdc3c7" />
              <stop offset="50%" stopColor="#ecf0f1" />
              <stop offset="100%" stopColor="#7f8c8d" />
            </linearGradient>
          </defs>

          <path d="M20 60 A80 60 0 0 1 180 60 L180 90 L20 90 Z"
            fill="#eb2a11" stroke="#3498db" strokeWidth="2" />

          <rect x="95" y="90" width="10" height="70" fill="#3d5f2a" />

          <polygon points="20,200 100,150 20,110"
            fill="url(#metal_2701)" stroke="#7f8c8d" strokeWidth="2" />

          <polygon points="180,200 100,150 180,110"
            fill="url(#metal_2701)" stroke="#7f8c8d" strokeWidth="2" />

        </svg>



        {/* ================= FACEPLATES ================= */}
        {openPanels.map((tag, index) => (
          <ControlValveControlPanel
            key={tag}
            tag={tag}
            data={valveData[tag]}
            update={updateValveData}
            close={() => closePanel(tag)}
            defaultPosition={{
              x: 300 + index * 40,
              y: 150 + index * 40
            }}
          />
        ))}




          {/* ================= CONTROL VALVE OUTPUTS ================= */}

      <ValveOutput
        value={Number(valveData?.FCV_2701?.opening || 0)}
        x={355}
        y={570}
      />


    <Transmitter
        tag="FIC_2701"
        value={[FIC_2701]}
        x={105}
        y={144}
        unit="BOE/M"
        max={20}
        HH={15}
        H={10}
        L={1}
        LL={0.5}
        c="lime"
        description="FLOWRATE OF GAS FROM PRODUCTION HEADER-2 TO SLUDGE CATCHER INLET"
      />



    <Transmitter
        tag="FIC_2702"
        value={[FIC_2702]}
        x={589}
        y={144}
        unit="SCF/S"
        max={150}
        HH={145}
        H={140}
        L={5}
        LL={3}
        c="lime"
        description="FLOWRATE OF GAS AT THE DISCHARGE OF SLUDGE CATCHER TO SLUDGE GAS SCRUBBER"
      />


    <Transmitter
        tag="FIC_2703"
        value={[FIC_2703]}
        x={1039}
        y={96}
        unit="SCF/S"
        max={150}
        HH={145}
        H={140}
        L={5}
        LL={3}
        c="lime"
        description="FLOWRATE OF GAS AT THE DISCHARGE OF SLUDGE GAS SCRUBBER TO HP COMPRESSOR SUCTION DRUM"
      />

    <Transmitter
        tag="FIC_2704"
        value={[FIC_2704]}
        x={483}
        y={436}
        unit="LPM"
        max={20}
        HH={15}
        H={10}
        L={1}
        LL={0.5}
        c="lime"
        description="FLOWRATE OF CRUDE FROM THE DISCHARGE OF SLUDGE CATCHER AND GAS SCRUBBER TO 3RD STAGE SEPARATOR"
      />

      <Transmitter4
      value={FIC_2705}
      x={573}
      y={426}
      c="transparent"
    />
      <Transmitter4
      value={FIC_2706}
      x={483}
      y={400}
      c="transparent"
    />

    <Transmitter
      tag="TT_2701"
      value={[TT_2701]}
      x={689}
      y={144}
      unit="°C"
      max={150}
      HH={120}
      H={100}
      L={20}
      LL={10}
      c="lime"
      description="TEMPERATURE OF GAS AT THE DISCHARGE OF SLUDGE CATCHER TO SLUDGE GAS SCRUBBER"
    />

    <Transmitter
      tag="PT_2701"
      value={[PT_2701]}
      x={782}
      y={144}
      unit="MPa"
      max={10}
      HH={8.5}
      H={7.6}
      L={0.04}
      LL={0.01}
      c="lime"
      description="PRESSURE OF GAS AT THE DISCHARGE OF SLUDGE CATCHER TO SLUDGE GAS SCRUBBER"
     />

    <Transmitter
      tag="PT_2702"
      value={[PT_2702]}
      x={1162}
      y={96}
      unit="MPa"
      max={10}
      HH={8.5}
      H={7.6}
      L={0.04}
      LL={0.01}
      c="lime"
      description="PRESSURE OF GAS AT THE DISCHARGE OF SLUDGE GAS SCRUBBER TO HP COMPRESSOR SUCTION DRUM"
     />



    
      <LevelTransmitterIndicator
      tag="LT_2701"
      totalLevel={90000}
      inflows={[FIC_2701]}
      outflows={[FIC_2706]}
      responseFactor={0.05}
      columnX={775}
      columnY={326}
      columnWidth={60}
      columnHeight={35}
      textX={854}
      textY={275}
      showFlow={true}
    />

      <LevelTransmitterIndicator
      tag="LT_2702"
      totalLevel={90000}
      inflows={[FIC_2703a]}
      outflows={[FIC_2705]}
      responseFactor={0.05}
      columnX={1012}
      columnY={270}
      columnWidth={70}
      columnHeight={140}
      textX={1100}
      textY={280}
      showFlow={true}
    />


    </div>
  );
}

export default SludgeCatcher;